import ResponsiveChatLayout from "../components/chat_components/ResponsiveChatLayout";
import MainLayout from "../components/MainLayout";

const ChatPage = () => {
  return (
    <MainLayout rs={false} pad={false} isMobilePadding={false}>
      <ResponsiveChatLayout />
    </MainLayout>
  );
};

export default ChatPage;
